import React from 'react'
import Create from '../crud/create'
import fields from './fields'
import menuItems from './menuItems'

const CreateResourceCategory = (props) => {
  return (
    <Create
// @ts-ignore
      title='Create Resource Category'
      fields={fields}
      apiPath='admin/resource_categories'
      successRedirectPath={resource => `/write-now/resource_categories/${resource.id}/edit`}
      buildMenuItems={menuItems}
    />
  )
}

export default CreateResourceCategory
